/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Pit1_DInputs */

const en_formatter_pit1_d = /** @type {(inputs: Formatter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A common bug in JSON formatters is passing the number 1 when the user asks for tabs, because the serializer treats a number as a space count. The result is one space per level, not a tab. This tool passes an actual tab character, so the Tab setting produces tab indented output that your editor will show at your configured tab width.`)
};

const ko_formatter_pit1_d = /** @type {(inputs: Formatter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 포매터에서 흔한 버그는 사용자가 탭을 선택했을 때 숫자 1을 넘기는 것입니다. 직렬화기는 숫자를 공백 개수로 해석하므로 결과는 탭이 아니라 단계당 공백 한 칸입니다. 이 도구는 실제 탭 문자를 넘기므로, Tab 설정은 에디터에 설정한 탭 너비로 보이는 탭 들여쓰기 출력을 만듭니다.`)
};

const ja_formatter_pit1_d = /** @type {(inputs: Formatter_Pit1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON フォーマッタでよくあるバグは、ユーザーがタブを選んだときに数値の 1 を渡してしまうことです。シリアライザは数値をスペース数として解釈するため、結果はタブではなく 1 段階あたり 1 スペースになります。このツールは実際のタブ文字を渡すので、Tab 設定はエディタのタブ幅で表示されるタブインデント出力になります。`)
};

/**
* | output |
* | --- |
* | "A common bug in JSON formatters is passing the number 1 when the user asks for tabs, because the serializer treats a number as a space count. The result is o..." |
*
* @param {Formatter_Pit1_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_pit1_d = /** @type {((inputs?: Formatter_Pit1_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Pit1_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_pit1_d(inputs)
	if (locale === "ko") return ko_formatter_pit1_d(inputs)
	return ja_formatter_pit1_d(inputs)
});